import { css } from "@xstyled/styled-components";
import styled from "styled-components";

export const PlayerContentWrapper = styled.div`
height: 100%;
width: 100%;
min-height: 60vh;
ul {
    list-style: none;
}
`

export const RecordingsList = styled.ul`
  padding: 0;
  margin: auto;
  height: 100%;
  width: 100%;
  margin-top: 1rem;
`

export const Recording = styled.li`
  ${({ theme }) => css`
    audio {
      display: none;
    }
    padding: 1rem;

    ${theme.mediaQueries.aboveMobile} {
    }
  `}
`

export const ControlsWrapper = styled.div`
  position: relative;

  img {
    display: block;
    height: 8vh;

  ${({ theme }) => theme.mediaQueries.aboveMobile} {
    img {
    }
  }
`

export const AudioButton = styled.button`
    display: inline-block;
    vertical-align: middle;
    align-items: center;
    justify-content: center;

    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 999;

    img {
        height: 40px;
    width: auto;
    user-select: none;
    }
`


export const ContributorData = styled.div`
  font-size: 12px;
  text-align: right;

  ${({ theme }) => theme.mediaQueries.aboveMobile} {
    font-size: 14px;
  }
`

export const PaginationWrapper = styled.div`
    display: flex;
    justify-content: space-between;
`

export const NextWrapper = styled.div`
    margin-left: auto;
`

export const PaginationButton = styled.button`
  ${({ theme }) => css`
    z-index: 999;
    ${theme.mediaQueries.aboveMobile} {
    }
  `}
`